// FA204 / frank trap — `_DOMPILER_PKG` used to be a bare module-scope const,
// read from inside this exported function's own body: unresolvable once
// this file's exports are individually frank.toJSON'd for platform delivery
// (project_frank_drops_module_local_helpers). Inlined as a local.
export const compileCode = async function compileCode(source, method) {
  // Computed specifier — @symbo.ls/dompiler's published entry lazy-loads a
  // NODEJS-target wasm artifact that can never ship in a browser bundle, and
  // a literal specifier makes Parcel statically traverse it and hard-fail
  // the WHOLE shell build when the artifact is absent (2026-08-07 dev-deploy
  // break: "Failed to resolve './dist/wasm/dompiler.js'"). Runtime
  // resolution (importmap / node ctx) is unaffected; a miss lands in the
  // try's catch as the existing "// Compilation Error:" fallback.
  // dompiler@ca04450 fixes the package side (ships the wasm, untraceable
  // inner loader); this keeps the consumer build independent of which
  // dompiler version the lock pins.
  const DOMPILER_PKG = ['@symbo.ls', 'dompiler'].join('/')
  let dist = source

  try {
    if (method === 'markdown-to-symbols') {
      const { MarkdownToDomQLCompiler } = this.context.functions
      const compiler = new MarkdownToDomQLCompiler()
      dist = compiler.compile(source, {
        componentName: 'MarkdownComponent'
      })
    } else if (method === 'symbols-to-react') {
      const { convertDomqlToReact } = await import(DOMPILER_PKG)
      const text = this.call('decodeNewlines', source).replace(
        'export default ',
        'export const Component = '
      )
      const compiled = await convertDomqlToReact(text)
      dist = await this.call('prettifyCode', compiled, {
        indent_size: 2,
        space_in_empty_paren: true,
        preserve_newlines: false,
        brace_style: 'collapse',
        break_chained_methods: false
      })
      dist = this.call('formatImports', dist)
    } else if (method === 'tailwind-to-symbols') {
      dist = '// Tailwind to Symbols compilation not yet implemented\n' + source
    } else if (method === 'symbols-to-tailwind') {
      dist = '// Symbols to Tailwind compilation not yet implemented\n' + source
    } else {
      dist = source
    }
  } catch (error) {
    console.error('Compilation error:', error)
    dist = `// Compilation Error:\n// ${error.message}\n\n${source}`
  }

  return dist
}
